import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { BaSidebar } from '../theme/components/baSidebar';
import { BaPageTop } from '../theme/components/baPageTop';
import { BaContentTop } from '../theme/components/baContentTop';
import { CanActivateTeam } from '../common/services/permission/guard.service';
import { routing } from './pages.routing';
import { NgaModule } from '../theme/nga.module';
//import {NgxPaginationModule} from 'ngx-pagination';
import { GenericPopupGridModule } from '../common/Popups/generic-grid/generic-popup-grid.module';

import { Pages } from './pages.component';

@NgModule({
  imports: [CommonModule, routing, GenericPopupGridModule, NgaModule],
  declarations: [Pages],
  providers: [CanActivateTeam],
})
export class PagesModule {}
